import React from "react";
import suggestedQuestions from "../../../../assets/imgs/suggested_questions.svg";
import dataVisualization from "../../../../assets/imgs/data-visualization.svg";
import trendingTopics from "../../../../assets/imgs/trending-topics.svg";

interface SuggestedQuestionsProps {
  suggestedQuestionsData: Array<{
    chatbot_suggestion: string;
  }>;
  onQuestionClick: (question: string, questionType?: string) => void;
  TrendingTopicsQuestions?: Array<{ chatbot_suggestion: string }>;
  DataVisualizationQuestions?: Array<{ chatbot_suggestion: string }>;
  chatbotAccess: boolean;
}

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({
  suggestedQuestionsData,
  onQuestionClick,
  TrendingTopicsQuestions,
  DataVisualizationQuestions,
  chatbotAccess,
}) => {
  return (
    <div className="pt-[20px] pb-[50px] flex flex-col space-y-[23px]">
      {!chatbotAccess && (
        <div>
          <span className="text-[14px] text-white font-medium underline">
            Free Suggested Questions
          </span>
        </div>
      )}
      <div>
        <div className="flex items-center gap-[10px]">
          <img src={trendingTopics} alt="trendingTopics" />
          <span className="text-[16px] text-white font-semibold">
            Trending Topics
          </span>
        </div>

        <div className="flex-col space-y-[10px] mt-5">
          {TrendingTopicsQuestions?.map((item, index) => (
            <div
              key={index}
              className={`flex items-center justify-between pb-[15px] transition-all duration-300 ease-in-out transform ${
                index !== TrendingTopicsQuestions.length - 1
                  ? "border-b-[1px] border-white/10"
                  : ""
              } cursor-pointer active:scale-95`}
              onClick={() =>
                onQuestionClick(item?.chatbot_suggestion, "trending_topic")
              }
            >
              <span className="text-white/85 text-[12px] font-medium">
                {item?.chatbot_suggestion}
              </span>
              <img
                src={suggestedQuestions}
                alt="suggestedQuestions"
                className="transition-transform duration-300 ease-in-out hover:rotate-12"
              />
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="flex items-center gap-[10px]">
          <img src={dataVisualization} alt="trendingTopics" />
          <span className="text-[16px] text-white font-semibold">
            Data Visualization
          </span>
        </div>

        <div className="flex-col space-y-[10px] mt-5">
          {DataVisualizationQuestions?.map((item, index) => (
            <div
              key={index}
              className={`flex items-center justify-between pb-[15px] transition-all duration-300 ease-in-out transform ${
                index !== DataVisualizationQuestions.length - 1
                  ? "border-b-[1px] border-white/10"
                  : ""
              } cursor-pointer active:scale-95`}
              onClick={() =>
                onQuestionClick(item?.chatbot_suggestion, "data_viz")
              }
            >
              <span className="text-white/85 text-[12px] font-medium">
                {item?.chatbot_suggestion}
              </span>
              <img
                src={suggestedQuestions}
                alt="suggestedQuestions"
                className="transition-transform duration-300 ease-in-out hover:rotate-12"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuggestedQuestions;
